export const apiURL = "https://api.redeartesanatobrasil.com.br/api/";
//export const apiURL = "http://127.0.0.1:8000/api/";
// export const apiURL = "https://api.beta.redeartesanatobrasil.com.br/api/";
